export default __webpack_public_path__ + "static/media/CanadaTravel.7e05d45c.jpg";